<template>
  <div class="urgentClose">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="accInfo">
        <p>账号</p>
        <div class="item">
          <div class="select-account-container">
            <SelectAccount :light="true" @onConfirmAccount="onConfirmAccount" />
          </div>
          <em @click="urgentNoticePop">平仓须知</em>
        </div>
      </div>
      <div class="urgentBG">
        <div class="urgentNav">
          <ul>
            <li v-for="(item,index) in urgentList" :class="{checked:tabIndex==index}" @click="tabClick(index,'close')"><span>{{ item.name }}</span></li>
          </ul>
        </div>
        <Position v-if="tabIndex==0" :platform="platform" :urgent-con="urgentCon" />
        <CancelOrder v-if="tabIndex==1" :platform="platform" :urgent-con="urgentCon" />
      </div>
    </div>
    <!--平仓须知-->
    <div v-if="isNotice" class="popFixed">
      <div class="masking" @click="urgentNoticePop" />
      <div class="tcCon">
        <div class="item">
          <span>平仓须知</span>
          <div class="explain">
            <p class="txtLeft">1）"紧急平仓"功能只接受为现有持仓单"平仓"及为现有挂单"撤单", 恕不接受新开仓、新锁仓单、新增挂单、取消止盈、取消止损及部分平仓指令</p>
            <p class="txtLeft">2）"紧急平仓"功能只适用于系统故障时使用，并只针对客户中心已正确加载的持仓及挂单记录，如对交易有其他疑问，请联系在线客服处理。</p>
            <p class="txtLeft">3）如客户曾使用不同渠道重复提交"平仓"或"撤单"指令，公司将以系统记录上最早提交的指令为准。</p>
            <p class="txtLeft">4）客户在任何情况下，皆有责任确保账号内的净值高于占用保证金(包括锁仓保证金)，以免遭受强制性平仓。</p>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="urgentNoticePop">知道了</span>
        </div>
      </div>
    </div>
    <!--緊急平倉須知-->
    <div v-if="isNoticeFirst" class="popFixed">
      <div class="masking" @click="urgentNoticePopFirst" />
      <div class="tcCon">
        <div class="item">
          <span>紧急平仓须知</span>
          <div class="explain">
            <p class="txtLeft">1）点击紧急平仓后，将由相关人员进行人工处理，不会马上执行平仓。 建议先进行页面截图。</p>
            <p class="txtLeft">2）如点击紧急平仓后，相关人员还未进行人工处理前，客户自行于软件点击平仓成功，将会依照自行于软件平仓价格与时间成交。</p>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="urgentNoticePopFirst">知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/urgentClose.css')
import Header from '@/view/module/Header.vue'
import Position from '@/view/urgentClose/Position.vue'
import CancelOrder from '@/view/urgentClose/CancelOrder.vue'
import { mapState } from 'vuex'
import SelectAccount from '@/view/module/SelectAccount.vue'
export default {
  name: 'UrgentClose',
  components: { Header, Position, CancelOrder, SelectAccount },
  computed: {
    ...mapState(['platformName', 'tabIndex', 'platform'])
  },
  data() {
    return {
      title: '紧急平仓',
      rightContent: 'isNo',
      urgentList: [{ name: '持仓' }, { name: '挂单' }, { name: '操作记录' }],
      urgentCon: 'close',
      isNotice: false,
      isNoticeFirst: true
    }
  },
  mounted() {
    this.initMounted()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    initMounted() {
      this.removeFixed()
      this.$bus.$emit('loading', true)
      window.scrollTo(0, 0)
    },
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    tabClick(index, type) {
      if (index == 2) {
        this.$bus.$emit('loading', false)
        this.$store.dispatch('setTabIndex', 0)
        this.$router.push({ path: '/home/urgentRecord' })
      } else {
        this.$store.dispatch('setTabIndex', index)
        this.urgentCon = type
      }
    },
    urgentNoticePop() {
      this.toggleFixed()
      this.isNotice = !this.isNotice
    },
    urgentNoticePopFirst() {
      this.toggleFixed()
      this.isNoticeFirst = !this.isNoticeFirst
    },
    onConfirmAccount() {
      this.initMounted()
    }
  }
}
</script>
